"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityRoleValue = exports.PersonRoleValueDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = require("styled-components");
var types_1 = require("@shapeable/types");
var theme_1 = require("@shapeable/theme");
var organisation_role_value_1 = require("./organisation-role-value");
var person_role_value_1 = require("./person-role-value");
exports.PersonRoleValueDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {};
var EntityRoleValue = function (props) {
  var className = props.className,
    entity = props.entity;
  var role = entity.role;
  var Container = (0, types_1.isPersonRole)(entity) ? person_role_value_1.PersonRoleValue : organisation_role_value_1.OrganisationRoleValue;
  return react_1.default.createElement(Container, {
    entity: entity,
    label: role.name,
    className: className
  });
};
exports.EntityRoleValue = EntityRoleValue;
person_role_value_1.PersonRoleValue.defaultProps = exports.PersonRoleValueDefaultProps;
var templateObject_1;